import type { ReactNode } from 'react';
import styled from 'styled-components';

export const Card = styled.section`
  min-width: 0;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.lg};
  box-shadow: ${({ theme }) => theme.shadow.sm};
  padding: 24px;
  animation: slideUp 0.35s ease both;

  @media (max-width: 600px) { padding: 20px 16px; }
`;

const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
`;

const TitleGroup = styled.div`
  min-width: 0;
  flex: 1 1 180px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.h2`
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const Description = styled.p`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.textMuted};
`;

interface CardHeaderProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function CardHeader({ title, description, action }: CardHeaderProps) {
  return (
    <Header>
      <TitleGroup>
        <Title>{title}</Title>
        {description && <Description>{description}</Description>}
      </TitleGroup>
      {action}
    </Header>
  );
}
